import { render, staticRenderFns } from "./setDuplicateLead.vue?vue&type=template&id=ca5c6b3e"
import script from "./setDuplicateLead.vue?vue&type=script&lang=js"
export * from "./setDuplicateLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports